import React, { useState } from 'react';
import { useTheme } from '@material-ui/core';
import defaultNCRLogo from 'src/common/media/ncr-logo-eps.svg';

interface ThemeLogoProps {
  styles: string;
}

const ThemeLogo: React.FC<ThemeLogoProps> = ({ styles }: ThemeLogoProps): JSX.Element => {
  const theme = useTheme();
  const [showImage, setShowImage] = useState<boolean>(true);

  return showImage ? (
    <img
      src={theme.mainLogo}
      className={styles}
      alt='store-logo'
      onError={() => {
        setShowImage(false);
      }}
    />
  ) : (
    <img src={defaultNCRLogo} className={styles} alt='default-ncr-logo' />
  );
};

export default ThemeLogo;
